/**
 * recruitment-media-api.js
 *  外部媒体関連のAPI
 */
import session from '../session'
import file from '../file'
import stream from '../stream'

// プロトタイプ宣言追加メソッド
import '@/hrm-frontend/modules/functions/prototype-extends'

var uri = process.env.API_ENDPOINT

export default {
  /**
   * 媒体連携項目マスターGETリクエスト
   * @returns レスポンス
   */
  getRecruitmentMediaInfo (queryParameter) {
    return session.get('{0}/api/hrm_apps/recruitment_media/recruitment_media_info?{1}'.format(uri, queryParameter))
  },
  /**
   * 媒体連携項目マスターPOSTリクエスト
   * @returns レスポンス
   */
  postMediaCooperationItemMaster (payload) {
    return session.post('{0}/api/hrm_apps/recruitment_media/media_cooperation_item_master'.format(uri), payload)
  },
  /**
   * 媒体連携項目マスターGETリクエスト
   * @returns レスポンス
   */
  getMediaCooperationItemMaster (queryParameter) {
    return session.get('{0}/api/hrm_apps/recruitment_media/media_cooperation_item_master?{1}'.format(uri, queryParameter))
  },
  /**
   * 媒体連携項目マスターPUTリクエスト
   * @returns レスポンス
   */
  putMediaCooperationItemMaster (payload) {
    return session.put('{0}/api/hrm_apps/recruitment_media/media_cooperation_item_master'.format(uri), payload)
  },
  /**
   * 媒体連携項目マスターPATCHリクエスト
   * @returns レスポンス
   */
  patchMediaCooperationItemMaster (payload) {
    return session.patch('{0}/api/hrm_apps/recruitment_media/media_cooperation_item_master'.format(uri), payload)
  },
  /**
   * 媒体連携項目マスターDELETEリクエスト
   * @returns レスポンス
   */
  deleteMediaCooperationItemMaster (queryParameter) {
    return session.delete('{0}/api/hrm_apps/recruitment_media/media_cooperation_item_master?{1}'.format(uri, queryParameter))
  },
  /**
   * 媒体関連ファイル処理GETリクエスト
   * @returns レスポンス
   */
  getRecruitmentMediaFile (queryParameter) {
    return session.get('{0}/api/hrm_apps/recruitment_media/file_processing?{1}'.format(uri, queryParameter))
  },
  /**
   * 媒体関連ファイル処理POSTリクエスト
   * @returns レスポンス
   */
  postRecruitmentMediaFile (payload) {
    return session.post('{0}/api/hrm_apps/recruitment_media/file_processing'.format(uri), payload)
  },
  /**
   * 媒体関連ファイル処理POSTリクエスト
   * ファイルアップロード用
   * @returns レスポンス
   */
  uploadRecruitmentMediaFile (payload) {
    return file.post('{0}/api/hrm_apps/recruitment_media/file_processing'.format(uri), payload)
  },
}



// WEBPACK FOOTER //
// ./src/api/recruitment-media/recruitment-media-api.js